import { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../lib/cn';
import { phoneCountry, phoneCountryOptions } from '../../lib/phone';
import styles from './PhoneField.module.css';

/**
 * Country dial-code picker + number input. The visible flag/code sits on top
 * of a transparent native <select>, so phones get their native picker.
 */
export const PhoneField = forwardRef(function PhoneField(
  { country = 'US', number = '', onCountryChange, onNumberChange, onBlur, id, name = 'phone', invalid, disabled, placeholder = 'Phone number', ...aria },
  ref
) {
  const current = phoneCountry(country);

  return (
    <div className={cn(styles.wrap, invalid && styles.invalid, disabled && styles.disabled)}>
      <div className={styles.prefix}>
        <span className={styles.flag} aria-hidden="true">
          {current.flag}
        </span>
        <span className={styles.dial} aria-hidden="true">
          {current.dialCode}
        </span>
        <ChevronDown className={styles.chevron} aria-hidden="true" />
        <select
          className={styles.select}
          value={current.code}
          aria-label="Country calling code"
          disabled={disabled}
          onChange={(e) => onCountryChange?.(e.target.value)}
        >
          {phoneCountryOptions.map((opt) => (
            <option key={opt.key} value={opt.key}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      <input
        ref={ref}
        id={id}
        name={name}
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        className={styles.input}
        placeholder={placeholder}
        value={number}
        disabled={disabled}
        onChange={(e) => onNumberChange?.(e.target.value.replace(/[^\d]/g, ''))}
        onBlur={onBlur}
        {...aria}
      />
    </div>
  );
});
